"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '20' : _ref$size,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#000000' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.3261 10.5061C17.5295 10.3318 17.6312 10.2446 17.6685 10.1408C17.7012 10.0498 17.7012 9.95017 17.6685 9.85911C17.6312 9.75536 17.5295 9.66818 17.3261 9.49381L10.2672 3.44331C9.91698 3.14314 9.74189 2.99306 9.59364 2.98939C9.46481 2.98619 9.34175 3.04279 9.26033 3.14269C9.16665 3.25764 9.16665 3.48825 9.16665 3.94948V7.52884C7.38775 7.84006 5.75965 8.74145 4.54975 10.0949C3.23069 11.5704 2.50103 13.4799 2.5 15.4591V15.9691C3.37445 14.9157 4.46625 14.0637 5.70062 13.4716C6.7889 12.9495 7.96533 12.6402 9.16665 12.5587V16.0505C9.16665 16.5117 9.16665 16.7423 9.26033 16.8573C9.34175 16.9572 9.46481 17.0138 9.59364 17.0106C9.74189 17.0069 9.91698 16.8568 10.2672 16.5566L17.3261 10.5061Z",
    stroke: fill,
    "stroke-width": "1.66666",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }));
};

exports["default"] = _default;